import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import { $Badge, Divider, NestedMenu, SvgIcon, hex2rgba } from 'prace-common-components'

export const $CallApplication = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(3)};
`

export const $PageTitle = styled.h3`
  margin: ${({ theme }) => `${theme.spacing(1)} 0`};
  color: ${({ theme }) => theme.colors.white};
  font-weight: lighter;
  font-size: 1.5em;
`

export const $ProposalID = styled.div`
  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.white};
`

export const $Param = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  margin-left: ${({ theme }) => theme.spacing(2)};
`

export const $ParamName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.primary};
`

export const $CallImage = styled.div<{src?: string}>`
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  margin-right: ${({ theme }) => theme.spacing(1)};
  font-weight: bold;
  color: white;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  display: flex;
  background: ${({src, theme }) => src ? 'no-repeat center/100% url('+ src +')' :
    `linear-gradient(45deg, ${theme.colors.secondary} 50%, ${hex2rgba(theme.colors.secondary, 0.88)} 50%)`};
  background-size: cover;
`

export const $GridCollapseContainer = styled(Grid)`
  height: fit-content;
  position: sticky;
  top: 90px;
  &>div {
    max-width: 300px;
  }
`

export const $ApplicationActions = styled(Grid)`
  padding: ${({ theme }) => `0 ${theme.spacing(3)}`};
  /* &>.MuiGrid-root {
    max-width: 220px;
  } */
`

export const $Buttons= styled(Grid)`
  &.MuiGrid-root {
    margin: ${({ theme }) => `${theme.spacing(2)} 0`};
  }
`

export const $AssignmentContainer = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(2)};
  h4 {
    margin-left: ${({ theme }) => theme.spacing(0.5)};
  }
  button {
    max-width: 200px;
  }
`

export const $CollapseContainer = styled.div`
  width: 100%;
  margin: ${({ theme }) => `${theme.spacing(1)} 0`};
  margin-left: ${({ theme }) => theme.spacing(2)};
`

export const $TimelineContainer = styled(Grid)`
  padding-top: ${({ theme }) => theme.spacing(1)};
`

export const $AddAssignment = styled(Grid)`
  &.MuiGrid-root {
    width: 100%;
    padding: 0;
  }
`

export const $TimelineEntry = styled.div`
  font-size: 0.9em;
`

export const $ChangesSnapshot = styled.div`
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  margin-left: ${({ theme }) => theme.spacing(2)};
  font-size: 0.85em;
`

export const $ChangesSnapshotToggle = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  font-size: inherit;
  font-family: inherit;
`

export const $ChangesSnapshotList = styled.ul`
  margin: ${({ theme }) => `${theme.spacing(0.5)} 0`};
  padding-left: ${({ theme }) => theme.spacing(2)};
`

export const $ChangesSnapshotItem = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing(0.25)};
  white-space: pre-line;
`

export const $ChangesSnapshotEmpty = styled.span`
  color: ${({ theme }) => theme.colors.grey};
  font-style: italic;
`

export const $ClickableUser = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
`

export const $VersionTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding-top: ${({ theme }) => theme.spacing(1)};
`

export const $VersionTab = styled.button<{ selected?: boolean }>`
  cursor: pointer;
  font-size: 0.85em;
  font-family: inherit;
  padding: ${({ theme }) => `${theme.spacing(0.25)} ${theme.spacing(1)}`};
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme, selected }) => selected ? theme.colors.primary : 'transparent'};
  color: ${({ theme, selected }) => selected ? theme.colors.white : theme.colors.primary};
`

export const $VersionMeta = styled.div`
  font-size: 0.8em;
  margin: ${({ theme }) => `${theme.spacing(0.5)} 0`};
`

export const $Chip = styled($Badge)`
  font-size: 0.9em;
  margin: 0;
  margin-top: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => `0 ${theme.spacing(1)}`};
`

export const $Divider = styled(Divider)`
  &.MuiDivider-root {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`

export const $ReviewContainer = styled.div`
  font-size: 0.9em;
  max-height: 100px;
  overflow-y: auto;
`

export const $ReviewEntry = styled.div`
  margin: ${({ theme }) => theme.spacing(0.5)};
  margin-left: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  white-space: pre-line;
`

export const $EmailTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  font-size: 0.85em;
`

export const $EditIcon = styled(SvgIcon)``

export const $NestedMenu = styled(NestedMenu)`
  .MuiList-root {
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.9em;
  }
`

export const $FormContainer = styled(Grid)<{ isMobile?: boolean }>`
  ${({isMobile}) => isMobile && 'padding: 0 16px;'}
`
